// @ts-nocheck
import React from "react";
import { useLanguageContext } from "../context/languageContext";
import { useSelector } from "react-redux";
import businessConfig from "../config/business";

/**
 * Welcome banner.
 *
 * The logo is a blue disc, so it cannot sit on a blue field - it vanishes. It is
 * given a white plate to sit on, against deep navy with a sand accent: the palette
 * every established seafood house uses, and the one their own logo already implies.
 */
export const WelcomeBanner = () => {
    const { t } = useLanguageContext();
    // Set when the guest scans the QR code on their table: /home?tableid=12
    const tableId = useSelector((state) => state.business.tableId);

    return (
        <section className="px-4 pt-4 pb-1 animate-app-reveal text-sharp">
            <div className="relative overflow-hidden rounded-[1.25rem] bg-[#0B1E3B] shadow-[0_10px_30px_-16px_rgba(11,30,59,0.9)]">
                {/* Depth, kept subtle so the logo plate stays the brightest thing here */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-20 -right-16 w-56 h-56 rounded-full bg-[#1B3B6F] opacity-60 blur-[70px]"></div>
                    <div
                        className="absolute inset-0 opacity-[0.05]"
                        style={{ backgroundImage: "radial-gradient(circle, white 1px, transparent 0)", backgroundSize: "18px 18px" }}
                    ></div>
                </div>

                <div className="relative z-10 flex items-center gap-4 px-5 py-5">
                    <div className="flex-shrink-0 w-[68px] h-[68px] rounded-full bg-white shadow-[0_6px_18px_-6px_rgba(0,0,0,0.6)] ring-1 ring-white/50 flex items-center justify-center">
                        <img
                            src={businessConfig.logo}
                            alt={businessConfig.name}
                            className="w-[58px] h-[58px] object-contain"
                        />
                    </div>

                    <div className="min-w-0 flex-1 space-y-1">
                        <p className="text-[8px] font-black uppercase tracking-[0.22em] text-[#E9C46A]">
                            {t("businessBadge", businessConfig.badge)}
                        </p>
                        <h1 className="text-[17px] sm:text-xl font-clash text-white tracking-tight leading-tight truncate">
                            {businessConfig.legalName.replace(/^Hotel-Restorant\s*/i, "")}
                        </h1>
                        <p className="text-white/45 text-[10px] font-medium leading-snug line-clamp-2">
                            {t("businessTagline", businessConfig.tagline)}
                        </p>
                    </div>
                </div>

                {tableId ? (
                    <div className="relative z-10 flex items-center justify-between gap-3 px-5 py-2.5 bg-white/[0.06] border-t border-white/10">
                        <span className="text-[9px] font-black uppercase tracking-[0.2em] text-white/50">
                            {t("welcome_banner")}
                        </span>
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#E9C46A] text-[#0B1E3B] text-[9px] font-black uppercase tracking-wider">
                            {t("Table", "Table")} {tableId}
                        </span>
                    </div>
                ) : (
                    <div className="relative z-10 px-5 py-2.5 bg-white/[0.06] border-t border-white/10">
                        <span className="text-[9px] font-black uppercase tracking-[0.2em] text-white/50">
                            {t("welcome_banner")}
                        </span>
                    </div>
                )}
            </div>
        </section>
    );
};
